import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Modal, Form, Input, Space, Button, Upload, Select, Row, Col, InputNumber, message } from 'antd'
import { PlusOutlined, EditOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from '../../../tool/axios'
import { SelectSingleProjectType } from '../../../component/common/Selects'
import { apiPrefix } from '../../../js/config'
import { formItemLayout, tailLayout } from '../../../js/globalParam'

import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'

import E from 'wangeditor'
import _ from 'lodash'

const { Option } = Select

const uploadFile = (e: { fileList: [] }) => {
    if (Array.isArray(e)) {
        return e
    }

    return e && e.fileList
}

const uploadButton = (
    <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
    </div>
)

export default function CkSingleListAddEdit() {

    const [fileList, setFileList] = useState<any[]>([])
    const [editorVisible, setEditorVisible] = useState<boolean>(false)
    const [editor, setEditor] = useState<null | any>(null)
    const [editType, setEditType] = useState<string>('')

    const [pageTitle, setPageTitle] = useState<string>('')
    const [tagList, setTagList] = useState<{ name: string, color: string, id: number }[]>([])

    const [itemTypeListId, setItemTypeListId] = useState<string | undefined>(undefined)
    const [coperationList, setCoperation] = useState<any[]>([])

    const [showConperation, setShowConperation] = useState<number>()

    const [prevHtml, setPrevHtml] = useState<string>('')
    const [prevViewVisible, setPreviewVisible] = useState<boolean>(false)
    const [formInstance] = Form.useForm()

    let { id }: { id: string } = useParams()

    const showEditModal = (which: string) => {
        setEditType(which)
        setEditorVisible(true)

        which === 'item_intro_detail' ? editor?.txt.html(formInstance.getFieldValue('item_intro_detail')) : editor?.txt.html(formInstance.getFieldValue('attention'))
    }

    const renderEditor = (cb: (e: any) => void) => {
        const editor = new E('.editor')

        editor.config.uploadFileName = "files"
        editor.config.uploadImgServer = apiPrefix + '/global/upload_pic'

        editor.config.uploadImgParams = {
            fileType: '1',
            bucketType: '4'
        }

        editor.config.uploadImgHeaders = {
            token: Cookies.get('token') || ''
        }

        editor.config.uploadImgHooks = {
            // 例如，服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
            customInsert: function (insertImgFn: any, result: any) {
                // result，即服务端返回的接口
                insertImgFn(result.data[0])
            }
        }

        editor.create()

        setEditor(editor)
        cb(editor)
    }

    const handleModalOk = () => {
        let html = editor?.txt.html()
        editType === 'item_intro_detail' ? formInstance.setFieldsValue({ item_intro_detail: html }) : formInstance.setFieldsValue({ attention: html })

        setEditorVisible(false)
        editor?.txt.html('')
    }

    // 金额输入框小数点控制后两位
    const limitDecimals = (value: any) => {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        // 取数字
        const data = value.replace(/[^0-9.]/g, "")

        // 取小数点后两位
        return data.replace(reg, '$1$2.$3')
    }

    // 提交
    const onFinish = (values: any) => {
        console.log('values', values)

        let item_flag: any[] = []

        let url: string = '',
            postData: any = {
                item_name: values.item_name,
                item_type_id: values.item_type_id,
                item_in_out: values.item_in_out,
                coperation_id: values.coperation_id,
                file_url_list: values.item_pic_vedio.map((item: any) => { return item.response.data.toString() }) || [],
                item_intro_detail: values.item_intro_detail,
                attention: values.attention,
                suggest_price: values.suggest_price,
                service_type: 1,
                service_time: values.service_time
            }

        if (values.suggest_price == 0) {
            message.warning('参考价格不能为0!')
            return false
        }

        if (values.item_flag.length > 3) {
            message.warning('项目标签数不能超过三个!')
            return false

        } else {
            {
                //拼接项目标签颜色给电商小程序用
                if (values.item_flag.length)
                    values.item_flag.map((item: any) => {
                        item_flag.push(`${item}&&&#000000`)
                    })
            }
        }

        if (!id) { // 新增
            url = '/chankang_center/item_single/add'
            postData.item_flag = item_flag.toString()

            axiosHandleEvent.post(url, { ...postData })

        } else { // 编辑
            url = '/chankang_center/item_single/update'
            postData.item_id = id
            postData.item_flag = item_flag.toString()

            axiosHandleEvent.post(url, { id, ...postData })
        }

    }

    const handleCoperation = (value: any) => {
        formInstance.setFieldsValue({ coperation_id: value })
    }

    // 初始相关数据
    useEffect(() => {
        // 获取产康合作商
        baseAxiosNoInfo.get('/chankang_center/coperation/select_list').then((response: any) => {
            setCoperation(response)
        })

        // 获取标签
        baseAxiosNoInfo.get('/global/flag_pool_list', { params: { flag_type: 1 } }).then((response: any) => {
            setTagList(response)
        })

        // 判断新增或编辑
        if (id) {
            baseAxiosNoInfo.get('/chankang_center/item_single/detail', { params: { item_id: id } }).then((res: any) => {
                if (res) {
                    let formData: any = {
                        item_type_id: res.item_type_id,
                        item_name: res.item_name,
                        service_time: res.service_time,
                        item_in_out: res.item_in_out,
                        suggest_price: res.suggest_price,
                        item_intro_detail: res.item_intro_detail,
                        attention: res.attention,
                        coperation_id: res.coperation_id,
                        item_flag: []
                    }

                    setItemTypeListId(res.item_type_id)

                    let flag = res.item_flag.split(',')
                    formData.item_flag = flag.map((el: any) => { return el.split('&&&')[0] })
                    formData.item_pic_vedio = res.file_url_list.map((el: { file_url: string, id: string }) => ({ url: el, id: el, uid: el, response: { data: [el] } }))
                    formData.item_intro_detail = Base64.fromBase64(res.item_intro_detail)
                    formData.attention = res.attention ? Base64.fromBase64(res.attention) : ''

                    setShowConperation(res.item_in_out)
                    formInstance.setFieldsValue(formData)
                }
            })

            setPageTitle('编辑产康单项')

        } else {
            setPageTitle('新增产康单项')
        }
    }, [1])

    useEffect(() => {
        if (editorVisible && editor === null && editType.length > 0) {
            renderEditor((e: any) => {
                editType === 'item_intro_detail' ? e?.txt.html(formInstance.getFieldValue('item_intro_detail')) : e?.txt.html(formInstance.getFieldValue('attention'))
            })
        }
    }, [editorVisible, editType])

    const PartnerOptions = coperationList.map((el: any) => (<Option value={el.coperation_id} key={el.coperation_id}>{el.coperation_name}</Option>))
    const TagOptions = tagList.map((el: any) => (<Option value={el.label_name} key={el.id}>{el.label_name}</Option>))

    return <div className="common-level2-edit">
        {/* 产康中心 -> 产康项目管理 -> 产康单项列表 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} name="validate_editor" onFinish={onFinish}>
                <Form.Item label="项目名称" name="item_name" rules={[{ required: true, message: '必须填写项目名称' }]}  >
                    <Input />
                </Form.Item>

                <Form.Item label="项目分类" name="item_type_id" rules={[{ required: true, message: '必须选择项目分类' }]}  >
                    <SelectSingleProjectType />
                </Form.Item>

                <Form.Item label="项目来源" name="item_in_out" rules={[{ required: true, message: '必须选择项目来源' }]}  >
                    <Select style={{ width: 140 }} placeholder="选择项目来源" onChange={(v: any) => { setShowConperation(v) }}>
                        <Option value={1}>自营</Option>
                        <Option value={2}>外部合作</Option>
                    </Select>
                </Form.Item>

                {showConperation === 2 && <Form.Item label="项目合作商" name="coperation_id" rules={[{ required: true, message: '必须选择合作商' }]} >
                    <Select style={{ width: 300 }} placeholder="选择项目合作商" onChange={(el: any) => { handleCoperation(el) }}>
                        {PartnerOptions}
                    </Select>
                </Form.Item>}

                <Form.Item label="项目标签（可多选）" name="item_flag" rules={[{ required: true, message: '必须选择套餐标签' }]} >
                    <Select mode="tags" style={{ width: '100%' }} placeholder="选择项目标签" >
                        {TagOptions}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="项目图片"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    name="item_pic_vedio"
                    extra="（最多可上传6张，大小不超过2M）"
                    rules={[{ required: true, message: '必须上传图片' }]}
                >
                    <Upload
                        name="files"
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                        fileList={fileList}
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item label="项目时长" name="service_time"
                    rules={[{ required: true, message: '必须填写项目时长' }]} >
                    <InputNumber style={{ width: 150 }} formatter={limitDecimals} placeholder="请填写分钟数" />
                </Form.Item>

                <Form.Item label="参考价格" name="suggest_price"
                    rules={[{ required: true, message: '必须选择参考价格' }]} >
                    <InputNumber style={{ width: 150 }} formatter={limitDecimals} placeholder="请填写参考价格" />
                </Form.Item>

                <Form.Item label="服务详情" name="item_intro_detail" rules={[{ required: true, message: '必须编辑服务详情' }]} >
                    <Space>
                        <Button onClick={() => { showEditModal('item_intro_detail') }} icon={<EditOutlined />}>编辑</Button>
                        <Button type="ghost" onClick={_ => {
                            setPrevHtml(formInstance.getFieldValue('item_intro_detail'))
                            setTimeout(_ => {
                                setPreviewVisible(true)
                            }, 100)
                        }}>手机版预览</Button>
                    </Space>
                </Form.Item>

                <Form.Item label="温馨提示" name="attention" rules={[{ required: true, message: '必须编辑产康功效' }]}  >
                    <Space>
                        <Button onClick={() => { showEditModal('attention') }} icon={<EditOutlined />}>编辑</Button>
                        <Button type="ghost" onClick={_ => {
                            setPrevHtml(formInstance.getFieldValue('attention'))
                            setTimeout(_ => {
                                setPreviewVisible(true)
                            }, 100)
                        }}>手机版预览</Button>
                    </Space>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">确定</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <Modal visible={editorVisible} onCancel={() => { setEditorVisible(false); editor?.txt.html('') }} width="800px" onOk={handleModalOk}>
            <div className="editor" style={{ marginTop: 50 }}></div>
        </Modal>

        <Modal visible={prevViewVisible} title="预览" footer={false} width="420px" onCancel={() => { setPreviewVisible(false); }}  >
            <div className="phone-preview" >
                <div className="phone-preview-content" dangerouslySetInnerHTML={{ __html: prevHtml }} ></div>
            </div>
        </Modal>
    </div>
}